var map = {
	"./idle.fbx": "2540",
	"./jump.fbx": "640f",
	"./left strafe walking.fbx": "a6fa",
	"./left strafe.fbx": "bfcd",
	"./left turn 90.fbx": "c45a",
	"./left turn.fbx": "25d4",
	"./right strafe walking.fbx": "3765",
	"./right strafe.fbx": "9ec4",
	"./right turn 90.fbx": "f0d4",
	"./right turn.fbx": "d65a",
	"./running.fbx": "f473",
	"./standard run.fbx": "3829",
	"./walking.fbx": "c65f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8640";